import React from "react";
import styles from "./Testimonials.module.css";
import { QUOTE_MARK, TESTIMONIALS } from "../assets";
import { fluidPx } from "../fluid";

export default function Testimonials() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.title}>
          <span className={styles.titleAccent}>Hear </span>
          <span className={styles.titleLight}>it from Industry Leaders</span>
        </h2>

        <ul className={styles.list}>
          {TESTIMONIALS.map((item) => (
            <li
              key={item.id}
              className={`${styles.item} ${
                item.mobileOnly ? styles.mobileOnly : ""
              }`}
            >
              <span className={styles.quoteMarks} aria-hidden="true">
                <img src={QUOTE_MARK} alt="" width={59} height={100} />
                <img src={QUOTE_MARK} alt="" width={59} height={100} />
              </span>

              <blockquote className={styles.card}>
                <p className={styles.quote}>{item.quote}</p>

                <footer className={styles.attribution}>
                  <div className={styles.person}>
                    {item.avatar && (
                      <img
                        src={item.avatar}
                        alt=""
                        className={styles.avatar}
                        loading="lazy"
                      />
                    )}
                    <div>
                      <p className={styles.name}>{item.name}</p>
                      <p className={styles.role}>{item.role}</p>
                    </div>
                  </div>
                  <img
                    src={item.logo}
                    alt={item.logoAlt}
                    className={styles.logo}
                    style={{ width: fluidPx(item.logoWidth) }}
                    loading="lazy"
                  />
                </footer>
              </blockquote>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
